import '../scss/excursions-list.scss'
import '@/shared-components/bootstrap.js'
import {Vue, lang} from '@/shared-components/index.js'
import { stringify, parse } from "qs";
import {store} from '../store';

Vue.component('excursions-filter', () => ({
    component: import('./components/ExcursionsFilter.vue'),
}));
Vue.component('excursions-search', () => ({
    component: import('./components/ExcursionsSearch.vue'),
}));
Vue.component('excursions-sort', () => ({
    component: import('./components/ExcursionsSort.vue'),
}));
Vue.component('excursions-mobile-sort', () => ({
    component: import('./components/ExcursionsMobileSort.vue')
}));
Vue.component('excursions-list', () => ({
    component: import('./components/ExcursionsList.vue')
}));

Vue.filter('choice', (...args) => {
    return lang.tc(...args);
});

export const excursionsList = new Vue({
    el: '#app',
    store,
    data: () => ({
        modalTabName: '',
        filters: {
            search: {},
            sort: '',
            filter: {},
            page: null,
        },
        total: 0,
    }),
    computed: {
        modalTab () {
            return this.$store.state.authModal.tab
        },
    },
    methods: {
        filterChange(data, filterName) {
            this.filters[filterName] = data;
            this.changeUrl(filterName)
        },
        changeUrl(filterName){
            const data = {
                ...this.filters.search,
                ...this.filters.filter
            };
            if(this.filters.sort) {
                data.sort = this.filters.sort
            }
            if(this.filters.page > 1 && filterName === 'page') {
                data.page = this.filters.page
            }
            let params = stringify(data,{
                encode: false,
                arrayFormat: 'indices',
                addQueryPrefix: true
            });
            const url = window.location.href.split('?')[0] + params;
            window.history.pushState('','', url);
            this.$refs.excursionsList.getExcursions();
            this.$refs.excursionsFilter.getExcursionsParams();
        },
        gatParamsFromUrl() {
            let query = parse(window.location.search, {
                depth: 2,
                ignoreQueryPrefix: true
            });
            if(query) {
                if(query.place) {
                    this.filters.search.place = +query.place;
                    delete query.place
                }
                if(query.date) {
                    this.filters.search.date = query.date;
                    delete query.date
                }
                if(query.sort) {
                    this.filters.sort = query.sort;
                    delete query.sort
                }
                if(query.page) {
                    this.filters.page = +query.page;
                    delete query.page
                }
                this.filters.filter = query
            }
        }
    },
    created() {
        this.gatParamsFromUrl()
    },
    mounted() {
        if(window.Laravel.user) {
            window.Laravel.user.csrfToken = window.Laravel.csrfToken;
            this.$store.dispatch('receiveUser', window.Laravel.user);
        }
        window.addEventListener('popstate', () => {
            this.gatParamsFromUrl();
            this.$refs.excursionsList.getExcursions();
            this.$refs.excursionsFilter.getExcursionsParams();
        })
    }
});
